import * as React from "react";
import { useEffect, useState } from "react";
import { preferencesService } from "../../../../modules/preferences/PreferencesService";
export function PreferenceCheckbox({ label, preferenceName, defaultCheckedFallback = false, valueMapping, tooltip, tooltipPosition, onChanged, disabled = false }) {
    const [isChecked, setIsChecked] = useState(undefined);
    useEffect(() => {
        const updateFromPreferences = () => {
            const schemaObj = preferencesService.schema.preferences.properties[preferenceName];
            let defaultValue = false;
            if (schemaObj !== undefined && schemaObj.type && schemaObj.type === "string") {
                defaultValue = schemaObj.default;
            }
            else if (defaultCheckedFallback) {
                defaultValue = defaultCheckedFallback;
            }
            let storedValue;
            if (valueMapping) {
                const value = preferencesService.getPreferredValue(preferenceName, defaultValue ? valueMapping.true : valueMapping.false);
                if (value && value === valueMapping.true) {
                    storedValue = true;
                }
                else if (value && value === valueMapping.false) {
                    storedValue = false;
                }
                else {
                    console.warn(`Stored value for preference ${preferenceName} is not a valid option: ${value}`);
                    storedValue = defaultValue;
                }
            }
            else {
                storedValue = preferencesService.getBooleanPreferredValue(preferenceName, defaultValue);
            }
            if (storedValue !== undefined) {
                setIsChecked(storedValue);
            }
        };
        updateFromPreferences();
        preferencesService.onStoreChanged.add(updateFromPreferences);
        return () => preferencesService.onStoreChanged.remove(updateFromPreferences);
    }, [defaultCheckedFallback, preferenceName, valueMapping]);
    useEffect(() => {
        if (isChecked === undefined) {
            return;
        }
        let valueToStore;
        if (valueMapping) {
            valueToStore = isChecked ? valueMapping.true : valueMapping.false;
        }
        else {
            valueToStore = isChecked;
        }
        preferencesService.updatePreferences([{ key: preferenceName, value: valueToStore }]);
        if (onChanged) {
            onChanged(isChecked);
        }
    }, [isChecked]);
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    return (React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": tooltip, "data-tooltip-position": tooltipPosition },
        React.createElement("input", { type: "checkbox", checked: isChecked !== null && isChecked !== void 0 ? isChecked : false, onChange: handleCheckboxChange, disabled: disabled }),
        React.createElement("label", null, label)));
}
